module.exports = __webpack_public_path__ + "static/media/Microbacia.2a522e23.svg";